import { IMG } from "./site";

const BOOK = "https://www.vagaro.com/luxveritaeskinspa";
const TEAM = "The Lux Veritae Team";

// Drafted SEO articles — please review before relying on them as medical guidance.
export const DRAFTS = [
  {
    slug: "co2-vs-erbium-laser-resurfacing-scottsdale",
    category: "Lasers",
    title: "CO₂ vs. Erbium Laser Resurfacing: Which Is Right for Your Skin?",
    dek: "Two of the most respected resurfacing lasers in aesthetics, explained — and how a Scottsdale consultation helps you choose.",
    author: TEAM, date: "The Edit", read: "4 min read", image: "/brand/art-laser-article.jpg",
    body: `Laser resurfacing remains one of the most effective ways to renew tired, textured or sun-damaged skin. At our Scottsdale medical spa, the two names clients ask about most are **CO₂** and **Erbium**. Both remove damaged outer layers of skin and encourage the body to rebuild fresh collagen — but they behave differently.

## The CO₂ laser: depth and transformation

A fractional CO₂ laser is an *ablative* laser that reaches deeper into the skin. It is often chosen for deeper wrinkles, pronounced sun damage, acne scarring and significant texture concerns. Because the treatment is more intensive, recovery is typically longer, and results tend to be more dramatic.

## The Erbium laser: precision with a gentler recovery

Erbium resurfacing is also ablative, but its energy is absorbed more superficially. It is frequently recommended for fine lines, mild to moderate texture and uneven tone, usually with less downtime than CO₂.

> The right laser is not the strongest one. It is the one calibrated to your skin, your goals and your calendar.

## How to choose

| Consideration | CO₂ | Erbium |
| --- | --- | --- |
| Best suited to | Deeper lines, scarring, sun damage | Fine lines, texture, tone |
| Intensity | Higher | Moderate |
| Typical downtime | Longer | Shorter |

Skin tone, medical history, the season and your social calendar all shape the recommendation. That is why every resurfacing plan at Lux Veritae begins with a consultation and, where required, review by our Medical Director.

## Preparing for resurfacing in Arizona

Desert sun is relentless. Daily broad-spectrum SPF before and after treatment protects your investment, and many clients schedule resurfacing in the cooler months.

[Book a laser consultation](${BOOK}) to discover which approach suits your skin.`,
  },
  {
    slug: "xerf-skin-tightening-scottsdale",
    category: "Skin Tightening",
    title: "Xerf: The Quiet Luxury of Non-Surgical Skin Tightening",
    dek: "Radiofrequency that works beneath the surface — for firmer, smoother skin without the scalpel.",
    author: TEAM, date: "The Edit", read: "3 min read", image: IMG.portrait2,
    body: `For clients who want visible firmness without surgery, **Xerf** has become one of the most talked-about treatments in modern aesthetics. It uses radiofrequency energy to gently heat deeper layers of the skin, encouraging the body's own collagen renewal.

## What Xerf addresses

- Loss of firmness along the jawline and neck
- Crepey texture on the face and body
- Early laxity after weight changes

## What to expect

Treatments are non-invasive, and most clients return to their day with little to no downtime. Collagen remodeling is gradual, so results typically build over the following weeks and months. Your provider will advise how many sessions suit your goals.

> Firmness, restored on your own terms — subtle, natural and entirely yours.

## Pairing for best results

Xerf is often combined with resurfacing lasers, RF microneedling or medical-grade skincare as part of a long-term plan. At Lux Veritae, every plan is personalized after a private consultation in our Scottsdale studio.

[Book your Xerf consultation](${BOOK}).`,
  },
  {
    slug: "cosmelan-chemical-peel-melasma-scottsdale",
    category: "Pigment",
    title: "The Cosmelan® Chemical Peel: A Clear Answer to Melasma",
    dek: "Why one of aesthetics' most advanced depigmentation peels has a devoted following — and what the journey looks like.",
    author: TEAM, date: "The Edit", read: "3 min read", image: IMG.peel,
    body: `Melasma, sun spots and stubborn discoloration are among the most common concerns we see in Scottsdale — and among the most frustrating. The **Cosmelan® chemical peel** is a professional depigmentation treatment designed to target pigment at its source.

## How it works

Cosmelan begins with an in-office mask applied by your provider, followed by a guided at-home maintenance routine. Together they help regulate excess pigment production and even out tone over time.

## Who it is for

- Melasma and hormonal pigmentation
- Sun spots and uneven tone
- Post-inflammatory hyperpigmentation (assessed at consultation)

> Pigment is persistent. A disciplined plan — and daily SPF — is what makes clarity last.

## The journey

Expect redness and peeling in the first days as skin renews. Improvement continues over the following weeks, and the at-home phase is essential. Your provider will guide every step and tailor aftercare to your skin.

[Book a Cosmelan consultation](${BOOK}) at Lux Veritae Skin Spa.`,
  },
  {
    slug: "body-contouring-scottsdale-cyroslimming-ems",
    category: "Body",
    title: "Body Contouring, Refined: CyroSlimming and EMS Muscle Toning",
    dek: "Non-surgical sculpting for the areas that resist diet and exercise.",
    author: TEAM, date: "The Edit", read: "3 min read", image: IMG.waxing,
    body: `Even the most disciplined routines leave a few stubborn areas. **Body contouring** at Lux Veritae pairs two technologies in one session: controlled cooling to target fat cells, and EMS (electrical muscle stimulation) to strengthen and tone.

## Why the combination works

Cooling targets stubborn fat while EMS engages the muscle beneath — reduction and definition, together, without surgery or downtime.

## Ideal candidates

Body contouring is designed for people near their goal weight who want refinement rather than weight loss. For broader goals, our physician-supervised medical weight loss programs can be paired with sculpting.

> Refinement, not reinvention — the final touch to the work you've already done.

## Your plan

Areas, number of sessions and spacing are personalized at consultation in our Scottsdale studio.

[Book a body contouring consultation](${BOOK}).`,
  },
];
